import { render } from "./viewqcm.vue?vue&type=template&id=4be05112"
import script from "./viewqcm.vue?vue&type=script&lang=js"
export * from "./viewqcm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__